import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=87d82edc&scoped=true"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEventModal.vue?vue&type=style&index=0&id=87d82edc&prod&lang=scss&scoped=true"
import style1 from "./CreateEventModal.vue?vue&type=style&index=1&id=87d82edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d82edc",
  null
  
)

export default component.exports